import '../../sass/layout/page/page-feel-hope.scss';

import Swiper, {
    Pagination,
    Autoplay,
} from 'swiper';

const swiperIcon= document.querySelector('.swiper-icon');

if (swiperIcon) {
    const pagination = swiperIcon.querySelector('.swiper-pagination');

    const options = {
        modules: [Pagination, Autoplay],
        loop: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 30,
        speed: 1000,
        pagination: {
            el: pagination,
            clickable: true
        },
        autoplay: false,
        autoplay: {
            delay: 5000,
        },
        breakpoints: {
            620: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            1024: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            }
        },
        init: true,
    }
    const swiper = new Swiper(swiperIcon, options);
}

const swiperSummary = document.querySelector('.swiper-summary');

if (swiperSummary) {
    const pagination = swiperSummary.querySelector('.swiper-pagination');

    const options = {
        modules: [Pagination, Autoplay],
        loop: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 34,
        speed: 1000,
        pagination: {
            el: pagination,
            clickable: true
        },
        autoplay: false,
        autoplay: {
            delay: 5000,
        },
        breakpoints: {
            620: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            1024: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            }
        },
        init: true,
    }
    const swiper = new Swiper(swiperSummary, options);
}

const swiperActions = document.querySelector('.swiper-actions');

if (swiperActions) {
    const pagination = swiperActions.querySelector('.swiper-pagination');

    const options = {
        modules: [Pagination, Autoplay],
        loop: false,
        speed: 1000,
        pagination: {
            el: pagination,
            clickable: true
        },
        autoplay: false,
        autoplay: {
            delay: 5000,
        },
        init: true,
    }
    const swiper = new Swiper(swiperActions, options);
}